import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

// Carte d'option (choix unique). Repos : surface, bordure 1px, texte blanc, icône grise.
// Sélectionnée : surface-2, bordure 1.5px rouge, icône blanche, pastille rouge + coche.
export const AnswerCard = ({ renderIcon, label, selected = false, onClick, dataTestId }) => (
    <button
        type="button"
        onClick={onClick}
        aria-pressed={selected}
        data-testid={dataTestId}
        className={cn(
            "tap-feedback w-full rounded-2xl px-4 flex items-center gap-4 text-left select-none active:scale-[0.98]",
        )}
        style={{
            minHeight: "var(--h-option)",
            height: "var(--h-option)",
            backgroundColor: selected ? "var(--surface-2)" : "var(--surface)",
            border: selected ? "1.5px solid var(--red)" : "1px solid var(--border)",
            transition:
                "background-color var(--dur-touch) var(--ease), border-color var(--dur-touch) var(--ease), transform var(--dur-touch) var(--ease)",
        }}
    >
        {renderIcon ? (
            <span className="shrink-0 w-5 flex items-center justify-center">{renderIcon(selected)}</span>
        ) : null}
        <span
            className="flex-1 font-body font-medium"
            style={{ fontSize: "16px", color: "var(--text)" }}
        >
            {label}
        </span>
        <span
            className="shrink-0 flex items-center justify-center rounded-full"
            style={{
                width: "20px",
                height: "20px",
                backgroundColor: selected ? "var(--red)" : "transparent",
                border: selected ? "none" : "1px solid var(--border)",
                transition: "background-color var(--dur-touch) var(--ease)",
            }}
        >
            {selected ? <Check size={13} strokeWidth={3} color="#FFFFFF" /> : null}
        </span>
    </button>
);
